import { AfterViewInit, Component, Input, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { Api } from '../../../api/api';
import { InputConverter, JSONConverter } from '../../../inputConverter';
import { LayerService } from '../../../services/layer.service';
import { IQuery } from '../../../types';
import { BaseComponent } from '../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-layer-filter-selector-ng',
    styleUrls: ['../../sharedStyles/base.scss', './layer-filter-selector.component.scss'],
    templateUrl: './layer-filter-selector.component.html'
})
export class LayerFilterSelectorComponent extends BaseComponent implements AfterViewInit {
    @Input()
    @InputConverter(JSONConverter)
    set selectedLayers(ids: number[]) {
        this._selectedLayers = ids;
        this.defineFiltersAndIds();
    }
    get selectedLayers(): number[] {
        return this._selectedLayers;
    }
    filtersAndIds: ITempFilterId[] = [];

    private _selectedLayers: number[];

    constructor(_vcr: ViewContainerRef, private readonly api: Api, private readonly layerService: LayerService) {
        super(_vcr);
    }

    async ngAfterViewInit() {
        this.isReady();
    }

    async defineFiltersAndIds() {
        const layerNames = await this.getLayerNames();
        for (const id of this.selectedLayers) {
            const name = layerNames.filter(x => x.id === id)[0].name;
            this.filtersAndIds.push({ id, query: null, name });
        }
    }

    async getLayerNames() {
        return await this.api.http2.graphqlRequest(`
        query {
            layers(id: [${this.selectedLayers}]){
                id
                name
            }
        }`, {}, 'GET', 'layers');
    }

    openFilter(layerId: number) {
        const layer = this.filtersAndIds.filter(x => x.id === layerId)[0];
        const openBasicFilter = new CustomEvent('openBasicFilter', { detail: { layer }, composed: true });
        window.dispatchEvent(openBasicFilter);
    }

    @Input() addQueryToList = (layerId: number, query: IQuery) => {
        this.filtersAndIds.find(x => x.id === layerId).query = query;
    }

    addLayersToMap() {
        for (const layer of this.filtersAndIds) {
            const layerSettings = {id: layer.id, query: layer.query ? layer.query : null};
            this.layerService.addMapcoreLayersToMap([layerSettings]);
        }
        this.selectedLayers = [];
        this.filtersAndIds = [];
        this.getClosestAncestor('mc-window').then(window => {
            if (window) {
                window.close();
            }
        });
    }
}

interface ITempFilterId {
    id: number;
    name: string;
    query?: IQuery;
}
